<template>
  <div>
    <v-dialog v-model="value" max-width="600" persistent scrollable>
      <v-card class="pa-4 pa-sm-8">
        <!-- {{candidateId}} -->
        <v-btn class="button-close ma-4" icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h4 class="mt-3 mb-3">Добавить документ</h4>
        <UploadBox
          :isFileUploaded="isFileUploadedSuccess"
          :loading="loading.create"
          :showError="showErrorUpload"
          @upload="clickSubmit"
        />
        <!-- <v-text-field :value="item.position" @input="onInput('name', $event)"
          :error-messages="fieldErrors('name')" outlined dense _hide-details
        /> -->
        <v-select
          v-model="item.type"
          :items="docTypes"
          item-text="text" item-value="value"
          label="Тип документа"
          class="mb-2" dense outlined
          :error-messages="fieldErrors('type')"
        >
        </v-select>
        <v-textarea label="Комментарий к документу" v-model="item.comment" @input="onInput('comment')"
          outlined dense hide-details rows="4" auto-grow
        />

        <div class="d-flex mt-4 justify-end">
          <v-btn class="mr-3 _w-100" outlined color="primary" @click="$emit('input', false)"> Отменить </v-btn>
          <v-btn class="_w-100" color="primary" @click="okClicked" :loading="loading.create"> Добавить </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import UploadBox from './UploadBox'
import { mapActions, mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { DOC_TYPES_TITLES, DOC_TYPES, DOC_SOURCES_TITLES, DOC_SOURCES } from '@/common/constants/docTypes';

export default {
  components: {
    UploadBox
  },
  props: ['value'],
  data() {
    return {
      formFile: null,
      isFileUploadedSuccess: false,
      showErrorUpload: false,
      docTypes: Object.entries(DOC_TYPES_TITLES).map(s => ({
        text: s[1],
        value: DOC_TYPES[s[0]]
      })),
      docSources: Object.entries(DOC_SOURCES_TITLES).map(s => ({
        text: s[1],
        value: DOC_SOURCES[s[0]]
      })),
      item: {
        type: '',
        comment: '',
        // name: '',
        // source: 'loaded',
      }
    }
  },
  validations: {
    item: {
      type: { required },  
    }
  },
  watch: {
    value(v) {
      if (v) {
        this.formFile = null;
        this.isFileUploadedSuccess = false;
        this.showErrorUpload = false
        this.item = { type: '', comment: '' }
        this.$v.$reset()
      }
    }
  },
  computed: {
    ...mapGetters({
      loading: 'users/dossiers/loading',
      candidateId: 'users/dossiers/candidateId',
    }),
  },
  methods: {
    ...mapActions({
      addDocument: 'users/dossiers/addDocument',
    }),
    fieldErrors(field) {
      const errors = [];
      if (!this.$v.item[field].$dirty) return errors;
      if (!this.$v.item[field].required) errors.push('Обязательное поле');
      return errors;
    },
    async clickSubmit (file) {
      this.showErrorUpload = false
      this.isFileUploaded = false
      this.isFileUploadedSuccess = false
      if (!(file.name.endsWith('.xlsx') || file.name.endsWith('.docx') || file.name.endsWith('.doc') || file.name.endsWith('.pdf') || file.name.endsWith('.txt'))) {
        this.$toast.error("Выберите файл формата DOCX, XLSX, или PDF", '', { position: 'topRight' });
        return
      }
      if (file.size >= 21000000) {
        this.$toast.error("Размер файла не должен быть более 20 Мб", '', { position: 'topRight' });
        return
      }
      this.formFile = file

      this.isFileUploadedSuccess = true
    },
    async okClicked() {
      if (!this.formFile) {
        this.showErrorUpload = true
        return
      }
      this.$v.$touch();
      if (this.$v.$invalid || this.loading.create) {
        return;
      }

      const form = new FormData()
      // form.append('name', this.item.name)
      form.append('source', 'loaded')
      form.append('type', this.item.type)
      form.append('comment', this.item.comment)
      form.append('file', this.formFile)
      try {
        const response = await this.addDocument(form)
      } catch (e) {
        if (e?.response?.data?.message) {
          const errorMessage = e.response.data.message
          this.$toast.error(errorMessage, '', { position: 'topRight' });
        } else {
          this.$toast.error("Ошибка загрузки", '', { position: 'topRight' });
        }
        return
      } finally {
        this.isFileUploaded = true
      }

      this.$emit('addDocument' )
      this.$emit('input', false)
    },
    onInput(field) {
      // console.log(field)
    }
  }
}
</script>

<style scoped>
.profile-item-title {
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  flex: 0 0 230px;
  width: 230px;
  padding: 8px 5px 0 0px;
}

.profile-item-value {
  flex: 0 0 calc(100% - 230px);
  width: calc(100% - 230px);
  padding: 0x 5px 0 5px;
}

</style>
